import { render, staticRenderFns } from "./PopupWorkoutPdfSend.vue?vue&type=template&id=be19a894"
import script from "./PopupWorkoutPdfSend.vue?vue&type=script&lang=js"
export * from "./PopupWorkoutPdfSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports